<template>
  <v-card>
    <v-card-title class="indigo darken-1" dark>
      <h2>
        <font style="color:white">Terminated Workers' Information</font>
      </h2>
      <v-spacer></v-spacer>

      <v-btn color="grey lighten-3" style="color:indigo darken-1; " small @click="handleClose">
        <v-icon>mdi-window-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-form ref="form" v-model="valid">
      <v-container>
        <v-col cols="12" md="12">
          <v-text-field
            label="Name of Worker"
            type="text"
            class="font-weight-normal"
            v-model="newItem.name"
            dense
            counter
            maxlength="50"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12">
          <v-autocomplete
            :items="getLesArray('jobTitle')"
            item-text="value"
            item-value="value"
            label="Job Title"
            dense
            v-model="newItem.jobTitle"
            class="font-weight-normal"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="12">
          <v-text-field
            label="Worker's Phone No."
            type="tel"
            class="font-weight-normal"
            v-model="newItem.phone"
            dense
            counter
            maxlength="50"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12">
          <v-text-field
            label="Email Address"
            type="email"
            class="font-weight-normal"
            v-model="newItem.email"
            dense
            counter
            maxlength="50"
            :rules="[inputRules.emailRule]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12">
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="computedDateFormatted1"
                label="Date of Employment"
                readonly
                v-on="on"
                dense
              ></v-text-field>
            </template>
            <v-date-picker v-model="dateValue1" no-title @input="menu1 = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="12">
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="computedDateFormatted2"
                label="Date of Termination"
                readonly
                v-on="on"
                dense
              ></v-text-field>
            </template>
            <v-date-picker v-model="dateValue2" no-title @input="menu2 = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="12">
          <v-text-field
            label="Salary"
            type="text"
            class="font-weight-normal"
            v-model="newItem.salary"
            dense
            counter
            maxlength="50"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12">
          <v-select
            :items="getLesArray('paymentMethods')"
            item-text="value"
            item-value="value"
            label="Indicate how Worker's salary was fixed"
            dense
            v-model="newItem.paymentMethods"
            class="font-weight-normal"
          ></v-select>
        </v-col>
      </v-container>
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn color="blue-grey darken-2" @click="handleClose" dark>
        <v-avatar left>
          <v-icon>mdi-close</v-icon>
        </v-avatar>Cancel
      </v-btn>

      <v-btn color="teal" @click="handleSave" dark v-if="valid">
        <v-avatar left>
          <v-icon>mdi-check</v-icon>
        </v-avatar>Confirm
      </v-btn>

      <v-btn
        color="deep-orange darken-4"
        @click="handleRemove"
        dark
        v-show="newItem.terminatedId != 'init'"
      >
        <v-avatar left>
          <v-icon>mdi-text-box-remove-outline</v-icon>
        </v-avatar>Remove
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    selectItem: {}
  },

  computed: {
    computedDateFormatted1() {
      return this.formatDate(this.dateValue1);
    },
    computedDateFormatted2() {
      return this.formatDate(this.dateValue2);
    }
  },
  data() {
    return {
      active: [],
      nodeDatas: [],
      newItem: JSON.parse(JSON.stringify(this.selectItem)),
      employerTerminated: this.getlesModel("employerTerminated"),
      dateValue1: this.selectItem.dateOfEmployment,
      dateValue2: this.selectItem.dateOfTermination,
      dateFormatted: null,
      menu1: false,
      menu2: false,
      inputRules: {
        numberRule: val => {
          if (!this.isNotBlankUtil(val)) {
            return true;
          }

          var r = /^\+?[1-9][0-9]*$/;
          if (!r.test(val) || val < 0) {
            return "Please enter Positive Integer";
          }

          // if (val < 0) {
          //   return "Please enter a positive number";
          // }
          return true;
        },
        emailRule: val => {
          if (!this.isNotBlankUtil(val)) {
            return true;
          }
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(val) || "Invalid e-mail.";
        }
      }
    };
  },
  methods: {
    handleSave() {
      this.$emit("update-item", this.newItem);
      this.$emit("childDialog");
    },
    handleRemove() {
      this.$emit("remove-item", this.newItem);
      this.$emit("childDialog");
    },
    handleClose() {
      this.$emit("childDialog");
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  },
  // beforeDestroy() {
  //   this.$emit("update-item", this.newItem);
  //   this.$emit("childDialog");
  // },
  watch: {
    dateValue1(val) {
      this.dateFormatted = this.formatDate(this.dateValue1);
      this.newItem.dateOfEmployment = this.dateValue1;
    },
    dateValue2(val) {
      this.dateFormatted = this.formatDate(this.dateValue2);
      this.newItem.dateOfTermination = this.dateValue2;
    }
  }
};
</script>
